var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.95399 5L9.78349 1.16531C10.0541 0.894309 10.0541 0.474255 9.78349 0.203252C9.51286 -0.0677507 9.09337 -0.0677507 8.82273 0.203252L4.99323 4.03794L1.16373 0.216802C0.893099 -0.0542005 0.473613 -0.0542005 0.202977 0.216802C-0.067659 0.487805 -0.067659 0.907859 0.202977 1.17886L4.03248 5.01355L0.216509 8.83469C-0.0541272 9.10569 -0.0541272 9.52575 0.216509 9.79675C0.487145 10.0678 0.906631 10.0678 1.17727 9.79675L5.00677 5.96206L8.83627 9.79675C9.1069 10.0678 9.52639 10.0678 9.79702 9.79675C10.0677 9.52575 10.0677 9.10569 9.79702 8.83469L5.95399 5Z",
    fill: "#002240"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageClose);
export default __webpack_public_path__ + "static/media/message-close.fa545628b5e2d27bb2c21afb5447772f.svg";
export { ForwardRef as ReactComponent };